import { AssignmentService } from './../forms/shared/assignment/shared/assignment.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Third party
import { TranslateModule } from '@ngx-translate/core';
import { Ng2TableModule } from 'ng2-table/ng2-table';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { NgSelectModule } from '@ng-select/ng-select';
import {FileUploadModule} from 'primeng/fileupload';

// Local
import { ExamplesRoutingModule } from './examples-routing.module';
import { FormsComponent } from './forms/forms.component';
import { SharedModule } from '../shared/shared.module';
import { Ng2TableComponent } from './ng2-table/ng2-table.component';
import { DateComponent } from './date/date.component';
import { DataTableComponent } from './data-table/data-table.component';
import { ControlSelectComponent } from './control-select/control-select.component';
import { CalculatorjsComponent } from './calculatorjs/calculatorjs.component';
import { SelectorModalComponent } from './selector-modal/selector-modal.component';
import { NumericDecimalComponent } from './numeric-decimal/numeric-decimal.component';
import { GalleryFilesComponent } from './gallery-files/gallery-files.component';
import { TinymceComponent } from './tinymce/tinymce.component';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { Const } from '@app/shared';
import { environment } from '@env/environment';
import { WebSocketComponent } from './websocket/websocket.component';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    PaginationModule,
    Ng2TableModule,
    NgSelectModule,
    FileUploadModule,
    ExamplesRoutingModule,
    EditorModule,
  ],
  declarations: [
    FormsComponent,
    Ng2TableComponent,
    DateComponent,
    DataTableComponent,
    ControlSelectComponent,
    CalculatorjsComponent,
    SelectorModalComponent,
    NumericDecimalComponent,
    GalleryFilesComponent,
    TinymceComponent,
    WebSocketComponent
  ],
  providers: [
    { provide: TINYMCE_SCRIPT_SRC, useValue: environment.servers_integrations.CITA.EDITORURL }
   ]

})
export class ExamplesModule { }



// WEBPACK FOOTER //
// ./src/app/examples/examples.module.ts